import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Sparkles, User, Bell, History, ShoppingBag, HelpCircle, LogOut, ChevronRight, Settings } from 'lucide-react';
import { Logo } from './Logo';
interface ProfileSettingsProps {
  energyPoints: number;
  onClose: () => void;
  onGoHome: () => void;
}
export function ProfileSettings({
  energyPoints,
  onClose,
  onGoHome
}: ProfileSettingsProps) {
  const settingsGroups = [{
    title: 'Konto',
    items: [{
      icon: User,
      label: 'Dane osobowe'
    }, {
      icon: History,
      label: 'Moje skany aury'
    }, {
      icon: ShoppingBag,
      label: 'Historia zamówień'
    }]
  }, {
    title: 'Preferencje',
    items: [{
      icon: Bell,
      label: 'Powiadomienia'
    }, {
      icon: Settings,
      label: 'Ustawienia aplikacji'
    }]
  }, {
    title: 'Inne',
    items: [{
      icon: HelpCircle,
      label: 'Pomoc i wsparcie'
    }, {
      icon: LogOut,
      label: 'Wyloguj się',
      textClass: 'text-red-500'
    }]
  }];
  return <motion.div className="flex flex-col items-center w-full max-w-lg z-10 pb-8 mt-4 p-4 min-h-screen" initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4
  }} data-id="element-730">
      {/* Header */}
      <div className="w-full flex items-center justify-between mb-8 px-2" data-id="element-731">
        <button onClick={onClose} className="w-10 h-10 rounded-full bg-white border border-slate-100 flex items-center justify-center text-slate-500 hover:text-zen-accent hover:border-zen-accent/30 transition-colors shadow-sm" aria-label="Wróć" data-id="element-732">
          <ArrowLeft className="w-5 h-5" data-id="element-733" />
        </button>
        <Logo onClick={onGoHome} data-id="element-734" />
        <div className="w-10 h-10" data-id="element-735"></div> {/* Spacer for centering */}
      </div>

      {/* Profile Info */}
      <div className="w-full flex flex-col items-center mb-10" data-id="element-736">
        <div className="relative mb-4" data-id="element-737">
          <div className="w-24 h-24 rounded-full bg-zen-bg border-4 border-white shadow-lg overflow-hidden" data-id="element-738">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop" className="w-full h-full object-cover opacity-90" alt="Avatar" data-id="element-739" />
          </div>
          <button className="absolute bottom-0 right-0 w-8 h-8 bg-zen-accent text-white rounded-full flex items-center justify-center border-2 border-white shadow-sm hover:bg-zen-accent/90 transition-colors" data-id="element-740">
            <Settings className="w-4 h-4" data-id="element-741" />
          </button>
        </div>

        <h2 className="text-2xl font-medium text-zen-text mb-1" data-id="element-742">Asia</h2>
        <p className="text-sm text-slate-400 mb-4" data-id="element-743">asia@example.com</p>

        <div className="clean-panel px-4 py-2 rounded-full flex items-center space-x-2 border-yellow-200 bg-yellow-50/50" data-id="element-744">
          <Sparkles className="w-4 h-4 text-yellow-500" fill="currentColor" data-id="element-745" />
          <span className="text-sm font-bold text-yellow-600" data-id="element-746">
            {energyPoints} Punktów Energii
          </span>
        </div>
      </div>

      {/* Settings List */}
      <div className="w-full space-y-6" data-id="element-747">
        {settingsGroups.map((group, groupIdx) => <div key={groupIdx} className="w-full" data-id="element-748">
            <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3 px-2" data-id="element-749">
              {group.title}
            </h3>
            <div className="clean-panel rounded-2xl overflow-hidden" data-id="element-750">
              {group.items.map((item, itemIdx) => {
            const Icon = item.icon;
            const isLast = itemIdx === group.items.length - 1;
            return <button key={itemIdx} className={`w-full flex items-center justify-between p-4 hover:bg-slate-50 transition-colors ${!isLast ? 'border-b border-slate-100' : ''}`} data-id="element-751">
                    <div className="flex items-center space-x-3" data-id="element-752">
                      <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center text-slate-500" data-id="element-753">
                        <Icon className="w-4 h-4" data-id="element-754" />
                      </div>
                      <span className={`text-sm font-medium ${item.textClass || 'text-zen-text'}`} data-id="element-755">
                        {item.label}
                      </span>
                    </div>
                    {item.label !== 'Wyloguj się' && <ChevronRight className="w-4 h-4 text-slate-300" data-id="element-756" />}
                  </button>;
          })}
            </div>
          </div>)}
      </div>
    </motion.div>;
}